import { TextField } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import injectStyles from 'react-jss'
import { useDispatch } from 'react-redux'
import { hideReduxModal } from '../../../Reducers/UI/actions'
import GenericFlatButton from '../../GenericFlatButton'

import { styles } from './styles'

const RejectModalBody = ({
  document,
  onRejectModalConfirm,
  setCustomDocument,
  handleCellChange,
  onCustomStatusChange,
  classes,
}) => {
  const [rejectReason, setRejectReason] = useState(null)

  const dispatch = useDispatch()

  useEffect(() => {
    setRejectReason(document.rejectReason)
  }, [])

  return (
    <div className={classes.modalContainer}>
      <div className={classes.modalTitle}>
        Do you want to leave any tips for BA?
      </div>
      <div className={classes.description}>
        This text will be displayed on the “Document individual screen“ in BA
        app
      </div>
      <TextField
        value={rejectReason}
        multiline={true}
        variant="outlined"
        minRows={10}
        maxRows={10}
        onChange={event => {
          const { value } = event.target
          if (value && value.length > 600) return
          setRejectReason(value)
          if (document.isCustomData) {
            return setCustomDocument({ ...document, rejectReason: value })
          }
          return handleCellChange(value, document, 'rejectReason')
        }}
        classes={{
          input: classes.rejectReasonInput,
          root: classes.rejectReasonInputRoot,
        }}
      />
      <div className={classes.counter}>{`Symbols: ${
        rejectReason ? rejectReason.length : 0
      } from 600`}</div>
      <div className={classes.modalButtonContainer}>
        <GenericFlatButton
          type={'outline'}
          title={'Cancel'}
          onClick={() => {
            dispatch(hideReduxModal())
          }}
        />
        <GenericFlatButton
          type={'outline'}
          title={'Skip and reject'}
          onClick={() => {
            onRejectModalConfirm({
              document,
              onCustomStatusChange,
            })
            dispatch(hideReduxModal())
          }}
        />
        <GenericFlatButton
          type={'filled'}
          title={'Save and reject'}
          onClick={() => {
            onRejectModalConfirm({
              document,
              rejectReason,
              onCustomStatusChange,
            })
            dispatch(hideReduxModal())
          }}
          disabled={!rejectReason || rejectReason.length < 1}
        />
      </div>
    </div>
  )
}

export default injectStyles(styles)(RejectModalBody)
